import { Grid, Skeleton } from "@mui/material";

const MainLoading = () => {
    return (
      <Grid container spacing={2} padding={2}>
        <Grid item xs={12} md={6}>
          <Skeleton variant="rectangular" height={300} />
          <Skeleton height={40} />
          <Skeleton height={20} width="60%" />
        </Grid>
        <Grid item xs={12} md={6}>
          <Skeleton variant="rectangular" height={300} />
          <Skeleton height={40} />
          <Skeleton height={20} width="70%" />
        </Grid>
      </Grid>
    );
  };
export default MainLoading